import { AccessEntryFields, GATE_GROUP, ACCESS_LOCATIONS } from './AccessEntryFields';

export const registrationAmenityRows = (value) => value?.locations || (value?.checked ? [{ location_name: 'Main', entry_code: value.entry_code || '', editing: value.editing, quantity: value.quantity }] : []);
export const registrationGateRows = (form) => form.gate_locations || (form.gate_code !== null ? [{ location_name: 'Main', entry_code: form.gate_code || '', editing: true }] : []);

export const RegistrationAccessFields = ({ catalog, amenities, setAmenities, form, setForm }) => {
  const groups = { [GATE_GROUP]: registrationGateRows(form) };
  Object.entries(amenities).forEach(([name, value]) => { groups[name] = registrationAmenityRows(value); });
  const names = [GATE_GROUP, ...new Set([...catalog, ...Object.keys(amenities)])];
  const updateRows = (name, transform) => {
    const sort = (rows) => rows.sort((a, b) => ACCESS_LOCATIONS.indexOf(a.location_name) - ACCESS_LOCATIONS.indexOf(b.location_name));
    if (name === GATE_GROUP) {
      setForm((state) => { const rows = sort(transform(registrationGateRows(state))); return { ...state, gate_locations: rows, gate_code: rows[0]?.entry_code || '' }; });
    } else setAmenities((state) => {
      const rows = sort(transform(registrationAmenityRows(state[name])));
      return { ...state, [name]: { ...state[name], checked: rows.length > 0, locations: rows, entry_code: rows[0]?.entry_code || '' } };
    });
  };
  const change = (name, i, patch) => updateRows(name, (rows) => rows.map((row, index) => index === i ? { ...row, ...patch } : row));
  return <section className="mobile-form-surface space-y-3" data-testid="register-amenities-block">
    <h2 className="text-base md:text-lg font-bold text-[#FFD60A]" data-testid="register-access-title">Access &amp; Entry</h2>
    <AccessEntryFields prefix="register-access" names={names} groups={groups} reveal
      onAdd={(name, location) => updateRows(name, (rows) => [...rows, { location_name: location, entry_code: '', editing: true }])}
      onEdit={(name, i) => change(name, i, { editing: true })}
      onChange={(name, i, entry_code) => change(name, i, { entry_code })}
      onSave={(name, i) => change(name, i, { editing: false })}
      onDelete={(name, i) => updateRows(name, (rows) => rows.filter((_, index) => index !== i))} />
  </section>;
};